module.exports = __webpack_public_path__ + "static/media/creative_01.0c4cc34b.jpg";